import { SystemIcon } from "@justworkshr/milo-icons";
import { ReactNode } from "react";
import styles from "./ComparisonTable.module.css";

type Feature = {
  name: ReactNode;
  eor: boolean;
  contractors: boolean;
};

const features: Feature[] = [
  {
    name: "Payroll for the whole team",
    eor: true,
    contractors: true,
  },
  {
    name: "Online onboarding & offboarding",
    eor: true,
    contractors: true,
  },
  {
    name: "Directory & org chart",
    eor: true,
    contractors: true,
  },
  {
    name: "Company census",
    eor: true,
    contractors: true,
  },
  {
    name: "Personalized, human support & expertise",
    eor: true,
    contractors: true,
  },
  {
    name: "PTO policies & holiday pay",
    eor: true,
    contractors: false,
  },
  {
    name: "Time tracking",
    eor: true,
    contractors: false,
  },
  {
    name: "Time off reports",
    eor: true,
    contractors: false,
  },
  {
    name: "Health insurance administration",
    eor: true,
    contractors: false,
  },
  {
    name: "Accounting & Performance Management Integrations",
    eor: true,
    contractors: false,
  },
];

const ComparisonTable = () => {
  const {
    comparisonTableContainer,
    featuresColumn,
    columnHeader,
    comparisonTable,
    featuresName,
    checkmarkCell,
  } = styles;

  return (
    <div className={comparisonTableContainer}>
      <table className={comparisonTable}>
        <thead>
          <tr>
            <th className={featuresColumn}>Features</th>
            <th className={columnHeader}>EOR</th>
            <th className={columnHeader}>Contractors</th>
          </tr>
        </thead>
        <tbody>
          {features.map((feature, index) => (
            <tr key={index}>
              <td className={featuresName}>{feature.name}</td>
              <td className={checkmarkCell}>
                {feature.eor && (
                  <SystemIcon
                    iconName="check-circle-inverted"
                    title="Check Icon"
                    color="success"
                    size="small"
                  />
                )}
              </td>
              <td className={checkmarkCell}>
                {feature.contractors && (
                  <SystemIcon
                    iconName="check-circle-inverted"
                    title="Check Icon"
                    color="success"
                    size="small"
                  />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ComparisonTable;
